<template>
    <div id="screendata">
        <el-button @click="choice(1)" :class="{'btncor':btnclr==1}">今日</el-button>
        <el-button @click="choice(7)" :class="{'btncor':btnclr==7}">7日</el-button>
        <el-button @click="choice(14)" :class="{'btncor':btnclr==14}">14日</el-button>
        <el-button @click="choice(30)" :class="{'btncor':btnclr==30}">30日</el-button>
        <el-button @click="choice(180)" :class="{'btncor':btnclr==180}">半年</el-button>
        <el-button @click="choice(0)" :class="{'btncor':btnclr==0}">全部</el-button>
    </div>
</template>
<script>
export default {
    name:'screendata',
    data(){
        return{
            btnclr:0
        }
    },
    methods:{
        choice(n){
            let choice = ''
            this.$set(this,'btnclr',n)
            if(n==1){
                let d = new Date();
                let year = d.getFullYear();
                let mon=d.getMonth()+1;
                let day=d.getDate();
                let nowtime = year+'-'+mon+'-'+day
                choice = nowtime+','+nowtime
            }else if(n==0){
                choice=0
            }else{
                let d = new Date();
                let year = d.getFullYear();
                let mon=d.getMonth()+1;
                let day=d.getDate();
                let nowtime = year+'-'+mon+'-'+day
                if(day <= n){
                    if(mon>1) {
                        mon=mon-1;
                    }else{
                    year = year-1;
                    mon = 12;
                    }
                }
                d.setDate(d.getDate()-n);
                year = d.getFullYear();
                mon=d.getMonth()+1;
                day=d.getDate();
                let s = year+'-'+(mon<10?('0'+mon):mon)+'-'+(day<10?('0'+day):day);
                choice = s+','+nowtime
            }
            this.$emit('choice',choice)
        }
    }
}
</script>
<style lang="scss">
    #screendata{
        float: right;
        margin-top: -7px;
    }
    #screendata .btncor{
        background: #67C23A;
        border:1px solid #67C23A;
        color: #fff
    }
    #screendata .el-button:hover{
        background:#67C23A;
        border:1px solid #67C23A;
        color: #fff
    }
    #screendata .el-button:focus{
        background: #67C23A;
        border:1px solid #67C23A;
        color: #fff
    }
</style>